import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const StyledComponent = styled<any, any>(
    'ul',
    'documentRecords',
    'documentsGrid'
)`
    ${propStyles};
    list-style: none;
    margin: 0 16px;
`;

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentRecords.tsx